import { NavLink, Outlet } from "react-router-dom";
import clsx from "clsx";

const TABS = [
  { to: "/account", label: "Profile", end: true },
  { to: "/account/orders", label: "Orders" },
  { to: "/account/wishlist", label: "Wishlist" },
  { to: "/account/wallet", label: "My Wallet" },
  { to: "/account/settings", label: "Settings" }
];

export function AccountLayout() {
  return (
    <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6 sm:py-16">
      <h1 className="text-display-sm mb-6 sm:mb-8">My account</h1>
      <nav className="no-scrollbar -mx-4 mb-8 flex gap-5 overflow-x-auto border-b border-border px-4 sm:mx-0 sm:mb-10 sm:gap-6 sm:px-0">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              clsx(
                "shrink-0 whitespace-nowrap pt-2 pb-4 text-sm font-medium border-b-2 -mb-px transition-colors duration-300",
                isActive ? "border-accent text-ink" : "border-transparent text-ink-muted hover:text-ink"
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </main>
  );
}
